import React, {useCallback, useEffect, useEffectEvent, useState} from 'react';
import {useSearchParams} from 'react-router';
import type {NoProps} from 'types';
import {useLocalization} from 'localization';
import {useAuthState} from 'services/auth/hooks/useAuthState';
import {ActionButton} from 'components';
import {REDIRECT_URI_NAME} from 'navigation/consts';
import {AppAnon} from 'app/AppAnon';

type Props = NoProps;

export const Login: React.FC<Props> = () => {
  const {login, canAttemptAutoSignin} = useAuthState();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);
  const onSetHasTriedSignin = useEffectEvent(setHasTriedSignin);

  const {t} = useLocalization();

  const [searchParams] = useSearchParams();

  const onLogin = useCallback(
    () =>
      login({
        url_state: searchParams.get(REDIRECT_URI_NAME) || undefined,
      }),
    [login, searchParams],
  );

  // automatically sign-in
  useEffect(() => {
    if (canAttemptAutoSignin() && !hasTriedSignin) {
      onLogin();
      onSetHasTriedSignin(true);
    }
  }, [canAttemptAutoSignin, hasTriedSignin, onLogin]);

  return (
    <AppAnon>
      <ActionButton
        data-cy={'login-button'}
        title={t('page.login.log_in')}
        onClick={onLogin}
      />
    </AppAnon>
  );
};
